// eslint-disable-next-line import/no-cycle
import { FieldConfig } from '@/types';
// eslint-disable-next-line import/no-cycle
import getConditionalDisplayField from '@/components/template-builder/config/fields/conditional-display-field-helper';
// eslint-disable-next-line import/no-cycle
import getLoopField from '@/components/template-builder/config/fields/loop-field-helper';

/**
 * Get conditions and repetition fields as an array
 * For use in array-based widget configurations
 * @param selector - CSS selector for the element (use #{ID} for widget ID)
 * @returns Array of field configurations
 */
const getConditionsAndRepetitionFields = (selector: string): FieldConfig[] => [
  getConditionalDisplayField(selector),
  getLoopField(selector),
];

export default getConditionsAndRepetitionFields;
